import type { ContractFunctionResult } from "@eulerxyz/core-sdk"
import type { BatchResultStatus } from "@eulerxyz/evc-sdk"
import type { Address } from "viem"
import { GenericVaultType } from "../../hooks"
import {
  type Asset,
  type NativeAsset,
  type TransactionItemUnion,
  TransactionItems,
  TransactionLabel,
} from "./baseTransactionTypes"
import { isUninstallTransactionItem } from "./eulerSwapTypes"
export type EvcTransactionLabels =
  | TransactionLabel.ENABLE_COLLATERAL
  | TransactionLabel.ENABLE_CONTROLLER
  | TransactionLabel.DISABLE_COLLATERAL
  | TransactionLabel.DISABLE_CONTROLLER
  | TransactionLabel.SET_ACCOUNT_OPERATOR

export type EvcTransaction = {
  label: EvcTransactionLabels
  vault: Address
  from: Address
  to: Address
  multiStepIndex?: number
  asset: Asset | NativeAsset
  result?: BatchResultStatus<ContractFunctionResult>
  transactions?: TransactionItems
  vaultType?: GenericVaultType
  subLabel?: string
}

export function isEVCTransactionItem(
  item?: TransactionItemUnion,
): item is EvcTransaction {
  return (
    item?.label === TransactionLabel.ENABLE_COLLATERAL ||
    item?.label === TransactionLabel.ENABLE_CONTROLLER ||
    item?.label === TransactionLabel.DISABLE_COLLATERAL ||
    item?.label === TransactionLabel.DISABLE_CONTROLLER ||
    item?.label === TransactionLabel.SET_ACCOUNT_OPERATOR
  )
}

export type EnableCollateralTransactionItem = EvcTransaction & {
  label: TransactionLabel.ENABLE_COLLATERAL
}
export function isEnableCollateralTransactionItem(
  item?: TransactionItemUnion,
): item is EnableCollateralTransactionItem {
  return item?.label === TransactionLabel.ENABLE_COLLATERAL
}

export type EnableControllerTransactionItem = EvcTransaction & {
  label: TransactionLabel.ENABLE_CONTROLLER
}

export function isEnableControllerTransactionItem(
  item?: TransactionItemUnion,
): item is EnableControllerTransactionItem {
  return item?.label === TransactionLabel.ENABLE_CONTROLLER
}

export type DisableCollateralTransactionItem = EvcTransaction & {
  label: TransactionLabel.DISABLE_COLLATERAL
}

export function isDisableCollateralTransactionItem(
  item?: TransactionItemUnion,
): item is DisableCollateralTransactionItem {
  return item?.label === TransactionLabel.DISABLE_COLLATERAL
}

export type DisableControllerTransactionItem = EvcTransaction & {
  label: TransactionLabel.DISABLE_CONTROLLER
}

export type SetAccountOperatorTransactionItem = EvcTransaction & {
  label: TransactionLabel.SET_ACCOUNT_OPERATOR
  account: Address
  operator: Address
  authorized: boolean
}

export function isDisableControllerTransactionItem(
  item?: TransactionItemUnion,
): item is DisableControllerTransactionItem {
  return item?.label === TransactionLabel.DISABLE_CONTROLLER
}
export function isCheckPositionStatusTransactionItem(
  item?: TransactionItemUnion,
): item is DisableCollateralTransactionItem | DisableControllerTransactionItem {
  return (
    item?.subLabel === "CHECKER_DISABLE_TO_PREVIOUS_CONTROLLERS" ||
    item?.subLabel === "CHECKER_DISABLE_TO_PREVIOUS_COLLATERALS"
  )
}
export function isDisableTransactionItem(
  item?: TransactionItemUnion,
): item is DisableCollateralTransactionItem | DisableControllerTransactionItem {
  if (isCheckPositionStatusTransactionItem(item)) {
    // It's a special case used on useCheckPositionsStatus we need to handle it different and not push to the button on the queue
    return false
  }
  return (
    isDisableCollateralTransactionItem(item) ||
    isDisableControllerTransactionItem(item) ||
    isUninstallTransactionItem(item)
  )
}

export function isSetAccountOperatorTransactionItem(
  item?: TransactionItemUnion,
): item is SetAccountOperatorTransactionItem {
  return item?.label === TransactionLabel.SET_ACCOUNT_OPERATOR
}
